import React from 'react'
import HistoryIcon from '@material-ui/icons/History';
import FlexView from 'react-flexview/lib';
import { ElevatedCircle } from '../../../Core/ElevatedCircle';
import { PolicyUpdateList } from './PolicyUpdateList';
import { isMobile } from 'react-device-detect';
import { SkywatchDialog } from '../../../PopUps/SkywatchDialog';
import NewFillButton from '../../../Core/NewFillButton';
import insuranceApi from "../../../../api/insurance.api";
import { awaitWithLoading } from '../../../../services/utils';

export const PolicyActivityHistory = ({insurance}) => {

    const [historyData, setHistoryData] = React.useState({open:false,history:undefined})
    
    const openDialog = async () => {
        const response = await awaitWithLoading(insuranceApi.getPolicyHistory(insurance.insuranceId))
        setHistoryData({open:true,history:response.data})
    }

    const closeDialog = () => {
        setHistoryData({open:false,history:undefined})
    }

    return (<React.Fragment>
            <FlexView vAlignContent={'center'} >
                <HistoryIcon fontSize="default"  />
                <div onClick={openDialog} className="text-small bold underline clickable margin-left-3">Policy activity history</div>
            </FlexView>
            <SkywatchDialog
                open={historyData.open}
                closeDialog={closeDialog}
                circleHeader={<ElevatedCircle> <HistoryIcon fontSize="large" className="blue" /> </ElevatedCircle>}
                closeTitle="Policy Activity History"
                maxWidth={'sm'}>
                    {!isMobile && <div className="text-title bold blue textcenter">Policy activity history</div>}
                    <PolicyUpdateList insurance={insurance} history={historyData.history} />
                    {!isMobile && 
                        <FlexView hAlignContent={'center'}>
                            <NewFillButton onClick={closeDialog}>Close</NewFillButton>
                        </FlexView>}
            </SkywatchDialog>
        </React.Fragment>
    )
}